import { ExternalLink } from "@octopusdeploy/design-system-components";
import { OverviewContainer, OverviewHighlightText } from "../../CommonComponents/CommonViews";
export const TenantVariablesCommonTemplatesPageHelp = () => (<OverviewContainer>
        <OverviewHighlightText>
            <p>Common templates define which variable values are required for each tenant connected to this project.</p>
            <br />
            <p>
                Common templates are defined in variable sets and allow tenants to provide a common variable value that is <b>shared</b> across projects and environments.
            </p>
            <br />
            <p>
                Learn more about&nbsp;
                <ExternalLink href="MultiTenantVariables">tenant-specific variables</ExternalLink>.
            </p>
        </OverviewHighlightText>
    </OverviewContainer>);
